import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { CreditTierView } from "./CreditTierView";
import { CreditTierViewStore } from "../../store/CreditTierViewStore";
import { useStore } from "../../../../hooks";

export const CreditTierViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/creditTier/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new CreditTierViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <CreditTierView creditTierViewStore={store} />
      </PageLayout>
    </div>
  );
});
